{
  "pages": {
    "guides": {
      "title": "Help guide",
      "description": "Our FAQ area is the best place to look to find answers to your questions. Our community\nand support team constantly updates the questions and answers."
    }
  },
  "components": {
    "guideList": {
      "actions": {
        "download": "Download instruction"
      },
      "noData": {
        "empty": {
          "title": "No guides available",
          "description": "We couldn't find any guides at this time. Please check back later."
        },
        "error": {
          "title": "Something went wrong",
          "description": "We couldn't load the guides at this time. Please try again later."
        }
      }
    }
  }
}
